<script>
import Layout from "@/router/layouts/auth";
import { mapState, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import Languages from "@/components/widgets/languages";
import Password from "@/components/widgets/input-password";

export default {
  components: {
    Layout,
    Languages,
    Password,
  },
  data() {
    return {
      language: "en",

      personNumberMask: "###.###.###-##",
      personNumber: "",
      password: "",

      loading: false,
      submitted: false,

      user: {
        name: "",
        personNumber: "",
        avatar: "",
      },

      enter: {
        welcome: {
          modal: true,
        },
        choose: {
          modal: false,
        },
      }
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },
  validations: {
    personNumber: { required },
    password: { required, minLength: minLength(6) },
  },
  created() {
    this.logout();
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { personNumber, password } = this;
        if (personNumber && password) {
          this.alert.type = "";
          this.alert.message = "";
          this.loading = true;
          this.$v.$reset();
          this.login({ personNumber, password });
        }
      }
    },
    clearUser() {
      this.personNumber = "";
      this.user.name = "";
      this.user.personNumber = "";
      this.user.avatar = "";
    },
  },
  mounted() {
  },
  watch: {
    "alert.type": function (alert) {
      if (alert == "alert-danger") {
        this.loading = false;
      }
    },
    personNumber(value) {
      if (value.length <= 14) {
        this.personNumberMask = '###.###.###-##';
      } else {
        this.personNumberMask = '##.###.###/####-##';
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div v-if="!enter.welcome.modal && !enter.choose.modal" id="auth">
      <div class="login-content d-flex">
        <div class="flex-fill">
          <div class="pb-2 text-center">
            <router-link class="align-middle" tag="a" to="/">
              <img class="w-100" style="max-width: 250px" src="@/assets/images/logo.png" />
            </router-link>
          </div>
          <div class="py-5">
            <b-form @submit.prevent="handleSubmit">
              <div v-if="alert.message" :class="'alert ' + alert.type">
                {{ alert.message }}
              </div>
              <b-form-group label="CPF/CNPJ" label-for="personNumber">
                <b-form-input v-model="personNumber" type="text" inputmode="numeric" :class="{ 'is-invalid': submitted && $v.personNumber.$error }" v-mask="personNumberMask"></b-form-input>
                <div v-if="submitted && !$v.personNumber.required" class="invalid-feedback">
                  O CPF/CNPJ é obrigatório
                </div>
              </b-form-group>
              <b-form-group label="Senha" label-for="password">
                <Password v-model="password" :v="$v.password"></Password>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                  Entrar
                  <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
            <div class="text-center pt-5">
              <router-link tag="a" to="/password-forgot" class="btn btn-outline-default btn-lg btn-block">
                <i class="mdi mdi-lock mr-1"></i>
                Esqueceu sua senha?
              </router-link>
              <Languages class="d-none" type="dropup"></Languages>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="enter.welcome.modal" modal-class="modal-fullscreen login-welcome" size="xl" hide-header hide-footer centered large>
      <div class="text-center">
        <img class="pulse-element mb-4" style="max-width: 200px" src="@/assets/images/logo-icon.png" />
        <h2 class="mb-3">Conheça a maior plataforma de telemedicina do Brasil 24hs na palma da sua mão.</h2>
        <h3 class="mb-4">Por um custo acessível, você tem médicos de várias especialidades 24hs com você.</h3>
        <button class="btn btn-primary btn-lg btn-block" v-on:click="enter.welcome.modal = false; enter.choose.modal = true">Continuar</button>
      </div>
    </b-modal>
    <b-modal v-model="enter.choose.modal" modal-class="modal-fullscreen login-choose" size="xl" hide-header hide-footer centered large>
      <div class="text-center">
        <img class="pulse-element mb-4" style="max-width: 200px" src="@/assets/images/logo-icon.png" />
        <h2 class="mb-3">A Medixe cuida da sua saúde com médicos 24hs sempre conectado com você.</h2>
        <h3 class="mb-4">Conectando você a saúde, na comodidade do seu lar ou aonde você estiver 24hs por dia.</h3>
        <router-link tag="a" to="/register" class="btn btn-primary btn-lg btn-block">Cadastrar</router-link>
        <button class="btn btn-outline-light btn-lg btn-block text-white" v-on:click="enter.choose.modal = false">Já possuo uma conta</button>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.pulse-element {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  /* Makes it a circle */
  animation: pulse 2s infinite ease-in-out;
  /* Apply the animation */
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    /* Slightly smaller at the start */
  }

  50% {
    transform: scale(1.1);
    /* Larger in the middle */
  }

  100% {
    transform: scale(0.9);
    /* Back to slightly smaller at the end */
  }
}

.modal-fullscreen {
  display: flex !important;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0;
  width: 100%;
  width: 100vw;
  min-height: 100dvh;
  /* iOS 16+ e modernos */
  min-height: 100svh;
  /* fallback p/ Safari 15.4+ */
}

@supports (-webkit-touch-callout: none) {
  .modal-fullscreen {
    min-height: -webkit-fill-available;
  }
}

.modal-fullscreen.login-welcome {
  background-image: url('~@/assets/images/login-1.jpg');
}

.modal-fullscreen.login-choose {
  background-image: url('~@/assets/images/login-2.jpg');
}

.modal-fullscreen .modal-dialog {
  margin: 0;
  max-width: 500px;
  height: 100%;
}

.modal-fullscreen .modal-content {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  min-height: 100dvh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: env(safe-area-inset-bottom);
}

@supports (-webkit-touch-callout: none) {
  .modal-fullscreen .modal-content {
    min-height: -webkit-fill-available;
  }
}

.modal-fullscreen .modal-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 40px 30px;
  width: 100%;
}

.modal-fullscreen .modal-body h2 {
  font-size: 1.4rem;
  color: #fff;
}

.modal-fullscreen .modal-body h3 {
  font-size: 1rem;
  font-weight: 400;
  color: #fff;
}
</style>